import React from 'react'
import * as Sentry from '@sentry/react'

class ErrorBoundary extends React.Component {
  state = {
    error: null
  }

  static getDerivedStateFromError = err => {
    return { error: { err } }
  }

  componentDidCatch = (error, errorInfo) => {
    console.error('Error found and caught', { error, errorInfo })

    // Log error with Sentry
    Sentry.captureException(error)

    sessionStorage.setItem(
      'caughtError',
      JSON.stringify(error, Object.getOwnPropertyNames(error))
    )
    window.location.href = `/error`
  }

  render () {
    if (this.state.error) {
      return null
    }

    return this.props.children
  }
}

export default ErrorBoundary
